import UIForm from './UIForm.container';
import Code from './fields/Code';
// TODO Remove for 6.0
import * as triggers from './utils/triggers';

export default UIForm;
export { UIForm, triggers, Code };
